import React from "react";
import { MessageOutlined } from "@ant-design/icons";
import { useChatMessageStore } from "../ChatBox/store";
import { useQuery } from "@tanstack/react-query";
import httpClient from "../../api/module/httpClient";
import { Badge } from "antd";

export default function ChatNotification(props) {

  const setShowMain = useChatMessageStore.getState().setShowMain;

  const { data } = useQuery({
    queryKey: ["TOTAL_CHAT_UNREAD_COUNT"],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/chat-messages/unread/count`);

      return data;
    },
  });


  return (
    <div
      style={{ marginRight: "1rem", cursor: "pointer", }}
      onClick={() => {
      setShowMain(true);
    }}
    >
      <Badge count={data?.total} overflowCount={999} >
        <div
          style={{
            fontSize: "30px",
          }}
        >
          <MessageOutlined style={{ width: "100%", height: "100%", color: "white" }} />
        </div>
      </Badge>
    </div>

  );
}